import { odbHttpClientV3 } from './http'

export async function getFopByCode({ code }) {
  try {
    const res = await odbHttpClientV3.get(`/fop/${code}`, {
      params: { apiKey: 'nHcfWZx4BjsF' }
    })
    return res.data
  } catch (err) {
    throw new Error(err.message)
  }
}
